var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "a",
    {
      staticClass: "file-select cf",
      class: { disabled: _vm.disabled },
      attrs: { href: "javascript:void(0)", disabled: _vm.disabled },
      on: {
        dragover: function ($event) {
          $event.preventDefault()
        },
        drop: function ($event) {
          return _vm.onDrop($event)
        },
        click: function ($event) {
          return _vm.labelClick()
        },
      },
    },
    [
      _c("input", {
        ref: "input",
        attrs: {
          type: "file",
          accept: _vm.formatAllowed,
          disabled: _vm.disabled,
          multiple: _vm.multiple,
        },
        on: {
          change: function ($event) {
            return _vm.onInput($event)
          },
          "file-pasted": function ($event) {
            return _vm.onInput($event)
          },
        },
      }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }